import React from 'react';
import '../../assets/css/ProfileStatus.css'
import { formatDateDDMMYYYYHHMMSS } from '../../Utils/data&dateTime';

const TransactionsStats = ({
    label,
    numbers,
    icon,
    percentage = 0,
    iconColor,
    bgColor,
    circleColor,
    widths = '285px',
    transactios,
    showCircle = true,
    onNumberClick,
    lastReconcileDate, // ✅ new prop
    onReconcileClick   // ✅ new prop
}) => {
    return (
        <div className="progress-card col-sm-2" style={{ backgroundColor: bgColor, width: widths }}>
            <div style={{ display: "flex", alignItems: 'center' }}>
                <div
                    style={{
                        height: '44px',
                        width: '44px',
                        borderRadius: '22px',
                        display: 'flex',
                        alignItems: 'center',
                        background: bgColor,
                        justifyContent: 'center',
                        marginRight: "20px"
                    }}
                >
                    <img src={icon} alt={label} className="progress-card-icon" />
                </div>
                <div className="progress-card-label">
                    <p
                        className="m-0"
                        style={{
                            color: iconColor,
                            fontSize: '30px',
                            fontWeight: '500',
                            cursor: label === "NEFT/RTGS/IMPS" ? 'default' : 'pointer',
                            textDecoration: label === "NEFT/RTGS/IMPS" ? 'none' : 'underline'
                        }}
                        onClick={() => {
                            if (label !== "NEFT/RTGS/IMPS" && onNumberClick) {
                                onNumberClick({
                                    type: label,
                                    numbers,
                                    transactios,
                                });
                            }
                        }}
                    >
                        {numbers}
                    </p>

                    <p className='m-0' style={{ color: iconColor, fontSize: '14px', fontWeight: '500' }}>
                        {label}
                    </p>

                    {transactios !== undefined && (
                        <p
                            className="m-0"
                            style={{
                                color: iconColor,
                                fontSize: "14px",
                                fontWeight: "500",
                            }}
                        >
                            Total amount : ₹{transactios || 0}
                        </p>
                    )}


                    {/* ✅ Only show for Cash In Hands */}
                    {label === "Cash In Hands" && (
                        <div className='d-flex align-items-center justify-content-between gap-3'>
                            {lastReconcileDate && (
                                <p className='m-0' style={{ color: iconColor, fontSize: '13px', fontWeight: '400' }}>
                                    Last Reconciliation: {formatDateDDMMYYYYHHMMSS(lastReconcileDate)}
                                </p>
                            )}
                            <svg
                                onClick={onReconcileClick}
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke={iconColor}
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{
                                    marginTop: "5px",
                                    cursor: "pointer",
                                    background: iconColor + "20", // light bg circle
                                    borderRadius: "50%",
                                    padding: "4px"
                                }}
                            ><title>Reconcile of Cash Amount</title>
                                <polyline points="23 4 23 10 17 10"></polyline>
                                <polyline points="1 20 1 14 7 14"></polyline>
                                <path d="M3.51 9a9 9 0 0114.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0020.49 15"></path>
                            </svg>

                        </div>
                    )}
                </div>
            </div>

            {/* ✅ Only show circle if showCircle is true */}
            {showCircle && (
                <div className="progress-card-body">
                    <div className="circle">
                        <svg width="50" height="50" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="40" cy="40" r="35" stroke="#ddd" strokeWidth="7" fill="none" />
                            <circle
                                cx="40"
                                cy="40"
                                r="35"
                                stroke={circleColor}
                                strokeWidth="5"
                                fill="none"
                                strokeDasharray={`${(percentage * 2.2)} 220`}
                                strokeLinecap="round"
                            />
                        </svg>
                        <div className="percentage" style={{ color: iconColor }}>
                            {percentage}%
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TransactionsStats;
